import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'

// Preview shown when every message of the conversation has been deleted
export const StyledDeletedPreviewText = styled(Text)`
    font-style: italic;
`

export const StyledConversationItem = styled(Flexbox).withConfig({
    shouldForwardProp: prop => prop !== 'isSelected' && prop !== 'isClickable'
})<{isSelected?: boolean; $isClickable: boolean}>(
    ({theme: {spacing, palette}, isSelected, $isClickable}) => css`
        padding: 0px ${spacing * 3}px;
        border-radius: 8px;
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};

        ${$isClickable &&
        css`
            transition: all 0.2s ease-in-out;
            cursor: pointer;
            &:hover {
                background-color: ${palette.neutral[50]};
            }
        `}

        ${isSelected &&
        css`
            background-color: ${palette.primary[50]};
            border-color: ${palette.primary[100]};

            &:hover {
                background-color: ${palette.primary[50]};
            }
        `}
    `
)

export const StyledConversationContent = styled(Flexbox)(
    ({theme: {spacing}}) => css`
        padding: ${spacing * 3}px 0px ${spacing * 2}px;
    `
)

export const StyledConversationMainInfo = styled(Flexbox)(
    () => css`
        flex: 1;
    `
)

export const StyledConversationBadgeDot = styled.div(
    ({theme: {palette}}) => css`
        width: 6px;
        height: 6px;
        border-radius: 6px;
        background-color: ${palette.primary[500]};
    `
)

export const StyledConversationFooter = styled(Flexbox)(
    ({theme: {spacing, palette}}) => css`
        padding: 0px 0px ${spacing * 3}px;
        & > svg {
            fill: ${palette.warning[500]};
        }
    `
)
